// import global from './global';
import drugControl from './drugControl';
import feeDispense from './feeDispense';
import member from './member';
import global from './global';
import clinicManagement from './clinicManagement';
import outPatient from './outPatient';
import statistic from './statistics';
import chainClinic from './chainClinic';
import chainManageStatistics from './chainManageStatistics';
import memberManagement from './memberManagement';
import systemSet from './systemSet';

export default {
  drugControl,
  feeDispense,
  member,
  global,
  clinicManagement,
  outPatient,
  statistic,
  chainClinic,
  chainManageStatistics,
  memberManagement,
  systemSet,
};
